import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ptBR from './locales/pt-BR.json';
import ptPT from './locales/pt-PT.json';
import enUS from './locales/en-US.json';
import esES from './locales/es-ES.json';
import frFR from './locales/fr-FR.json';

import flagBR from '@/assets/flags/br.webp';
import flagPT from '@/assets/flags/pt.jpg';
import flagUS from '@/assets/flags/us.png';
import flagES from '@/assets/flags/es.jpg';
import flagFR from '@/assets/flags/fr.jpg';

// Lista de idiomas suportados com metadados
export const supportedLanguages = [
  { code: 'pt-BR' as const, name: 'Português (Brasil)', flag: '🇧🇷', flagImage: flagBR, nativeName: 'Português' },
  { code: 'pt-PT' as const, name: 'Português (Portugal)', flag: '🇵🇹', flagImage: flagPT, nativeName: 'Português' },
  { code: 'en-US' as const, name: 'English (US)', flag: '🇺🇸', flagImage: flagUS, nativeName: 'English' },
  { code: 'es-ES' as const, name: 'Español', flag: '🇪🇸', flagImage: flagES, nativeName: 'Español' },
  { code: 'fr-FR' as const, name: 'Français', flag: '🇫🇷', flagImage: flagFR, nativeName: 'Français' },
];

export type SupportedLanguage = typeof supportedLanguages[number]['code'];

// Recursos de tradução
const resources = {
  'pt-BR': { translation: ptBR },
  'pt-PT': { translation: ptPT },
  'en-US': { translation: enUS },
  'es-ES': { translation: esES },
  'fr-FR': { translation: frFR },
};

// Inicialização do i18next
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt-BR',
    supportedLngs: supportedLanguages.map(l => l.code),
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'brooklyn_language',
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },
  });

export const changeLanguage = async (lang: SupportedLanguage) => {
  await i18n.changeLanguage(lang);
  localStorage.setItem('brooklyn_language', lang);
  document.documentElement.lang = lang;
};

export const getCurrentLanguage = (): SupportedLanguage => {
  return (i18n.language || 'pt-BR') as SupportedLanguage;
};

export const getCurrentLanguageData = () => {
  const current = getCurrentLanguage();
  return supportedLanguages.find(l => l.code === current) || supportedLanguages[0];
};

export default i18n;
